import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=d2e99a0c&scoped=true&"
import script from "./EditForm.vue?vue&type=script&lang=js&"
export * from "./EditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e99a0c",
  null
  
)

export default component.exports